import { Field, FlexProps } from '@chakra-ui/react';
import { MdOutlineFileUpload } from 'react-icons/md';
import { MFlex, MText } from '../../../../../components/Monetize';

interface ReplaceButtonProps extends FlexProps {
  onReplace: () => void;
}
export const ReplaceButton: React.FC<ReplaceButtonProps> = ({
  onReplace,
  ...rest
}) => {
  return (
    <MFlex
      justifyContent="space-between"
      alignItems="center"
      onClick={onReplace}
      {...rest}
    >
      <Field.Root>
        <Field.Label>File</Field.Label>
      </Field.Root>
      <MFlex gap={1} alignItems={'center'} cursor="pointer">
        <MdOutlineFileUpload color="#4659DA" />
        <MText color={'tBlue.400'}>Replace File</MText>
      </MFlex>
    </MFlex>
  );
};

export default ReplaceButton;
